'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'inbox';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f01c';
var svgPathData = 'M16 336l0 128 480 0 0-128-123.7 0-29.6 44.4-2.4 3.6-168.6 0-2.4-3.6-29.6-44.4-123.7 0zm479.9-16l-30.2-272-419.4 0-30.2 272 132.2 0 2.4 3.6 29.6 44.4 151.4 0 29.6-44.4 2.4-3.6 132.2 0zM0 320l32-288 448 0 32 288 0 160-512 0 0-160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faInbox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;